import { useTranslation } from 'react-i18next';
import Shimmer from '@app/components/shimmer/Shimmer';
import formatAmount from '@modules/calculator/utils/formatAmount';
import { getDemoCalculatorData } from '@modules/calculator/utils/getDemoCalculatorData';
import CalculatedResultsItem from './CalculatedResultsItem';
import CalculatedResultsItemValue from './CalculatedResultsItemValue';
const CalculatedResultsList = ({ isDemo, calculationsData, isCalculationsLoading, exampleText }) => {
    const { t } = useTranslation();
    const { isMonthlyPaymentLimitExceeded, maximumMonthlyPaymentLimit } = calculationsData || {};
    const dataForRender = getDemoCalculatorData(t, calculationsData);
    const monthlyPayment = dataForRender.find((item) => 'isMonthlyPaymentLimitExceeded' in item);
    const otherItems = dataForRender.filter((item) => !('isMonthlyPaymentLimitExceeded' in item));
    const showLimitHint = !isCalculationsLoading && isMonthlyPaymentLimitExceeded && maximumMonthlyPaymentLimit;
    return (<div className="grow basis-[280px] p-6 rounded-lg flex flex-col gap-4 bg-soft-gradient">
            {monthlyPayment && (<div className="flex flex-col gap-2 pb-4 border-b border-neutral-primary-initial">
                    <p className="body-s">{monthlyPayment.label}</p>
                    <p className="headline-s">
                        <CalculatedResultsItemValue isLoading={isCalculationsLoading} item={monthlyPayment}/>
                    </p>
                    {showLimitHint && (<p className="body-s text-critical-primary-initial" role="alert">
                            {t('financing_calculator_max_monthly_payment', {
                    amount: formatAmount(Number(maximumMonthlyPaymentLimit)),
                })}{' '}
                            {t('financing_calculator_choose_longer_period_or_smaller_amount')}
                        </p>)}
                </div>)}
            <div className={`flex flex-col gap-3 ${isDemo && (isCalculationsLoading || exampleText) ? 'border-b border-neutral-primary-initial pb-3' : ''}`}>
                {otherItems.map((item) => (<CalculatedResultsItem key={item.label} item={item} isLoading={isCalculationsLoading}/>))}
            </div>
            {isDemo &&
            (isCalculationsLoading ? (<div className="flex flex-col gap-2">
                        <Shimmer className="rounded h-3 w-full"/>
                        <Shimmer className="rounded h-3 w-full"/>
                        <Shimmer className="rounded h-3 w-full"/>
                        <Shimmer className="rounded h-3 w-2/3"/>
                    </div>) : (exampleText && <p className="body-s text-neutral-secondary-initial">{exampleText}</p>))}
        </div>);
};
export default CalculatedResultsList;
